var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loader', { 'is-inline': _vm.inline }]},[_c('b-spinner',{attrs:{"type":_vm.type,"variant":_vm.variant,"small":_vm.small,"label":_vm.label}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }